"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4278],{

/***/ 88921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53297);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40038);
/* harmony import */ var modules_queue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17438);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36888);
/* harmony import */ var modules_user_optIn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78159);







const ResolvePostponed = (param)=>{
    let { children, withoutPremiumModal, withNotification } = param;
    const { isLoggedIn, isFetching: isUserFetching } = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .aF)();
    const { subscription, isFetching: isSubscriptionFetching } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_3__/* .useSubscription */ .mU)();
    const isFetching = isUserFetching || isSubscriptionFetching;
    // ATTN we can't add LEP if user doesn't have an active subscription
    const isSubscriptionActive = (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) ?? false;
    const postponedItemsHandler = (0,modules_queue__WEBPACK_IMPORTED_MODULE_4__/* .useQueueResolvePostponedItems */ .oB)();
    const postponedOptInEmailHandler = (0,modules_user_optIn__WEBPACK_IMPORTED_MODULE_5__/* .useOptInEmailResolvePostponedProjects */ .TJ)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isFetching) {
            return;
        }
        if (isLoggedIn) {
            postponedItemsHandler({
                withNotification,
                withUpgradeFlow: false,
                withErrorModals: false,
                withLEP: isSubscriptionActive,
                withPriorityProducts: isSubscriptionActive,
                withoutPremiumModal
            }).catch((error)=>{
                logger__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.warn(error);
            });
            // Send user email to postponed iterable projects
            postponedOptInEmailHandler();
        }
    }, [
        postponedItemsHandler,
        postponedOptInEmailHandler,
        isFetching,
        isLoggedIn,
        isSubscriptionActive,
        withNotification,
        withoutPremiumModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ResolvePostponed);


/***/ })

}]);